module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "page-lock"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    staticClass: "lock-head"
  }, [_vm._v("Two-Step Verification")]), _vm._v(" "), _c('div', {
    staticClass: "lock-body"
  }, [_c('form', {
    staticClass: "two-factor-form-wrapper",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleFormSubmit.apply(null, arguments)
      }
    }
  }, [_c('h4', {
    staticClass: "text-center mb-20 fw-400"
  }, [_vm._v("\n            Enter the verification code we emailed "), _c('br'), _vm._v("\n            you to " + _vm._s(_vm.email) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage !== null),
      expression: "errorMessage !== null"
    }],
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "two-factor-form"
  }, [_c('div', {
    staticClass: "mb-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    staticClass: "form-control placeholder-no-fix two-factor-form__input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "6-Digit Code",
      "name": "password"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "two-factor-form__buttons"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn default btn--big uppercase",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Cancel")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "lock-bottom"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSendVerificationCodeAgain.apply(null, arguments)
      }
    }
  }, [_vm._v("Email me with new code.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer-custom"
  }, [_vm._v("\n      © " + _vm._s(_vm.getCurrentYear) + " CaseMGR Solutions, Inc. All Rights Reserved.\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logo"
  }, [_c('a', {
    staticClass: "brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/pages/img/logo.png",
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-warning btn--big uppercase ladda-button js-submit-btn",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Sign In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-0"
  }, [_c('strong', [_vm._v("Need a new code?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8639112","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoginTwoFactor.vue
// module id = 1761
// module chunks = 1